
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-4-09 (1.0.0) (jhoward)
 *    - Copy from Easter_defaultSection.vue component to MothersDay_defaultSection.vue component.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";

export default defineComponent({
  components: {
    DefaultVisualSection, DefaultTextualSection,
  },
  name: "MothersDay_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menuVersion: {
      type: String,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menu: {
      type: Object as PropType<Menu | null>,
      required: true
    },
    menuItemComponent: {
      type: String as PropType<'mothers-day-food-item' | 'mothers-day-cocktail-item'>,
      default: 'mothers-day-food-item'
    }
  },
  mounted() {
    this.section.ms_title = this.sectionTitle();
    this.section.ms_subtitle = this.sectionSubtitle();
  },
  data: function () {
    return {};
  },
  methods: {
    sectionTitle(): string {
      if ('mother\'s day menu' === this.section.ms_title.toLowerCase()) {
        return 'MOTHER\'S DAY DINING';
      }

      return this.section.ms_title.toUpperCase();
    },
    sectionSubtitle(): string {
      return (this.menu?.page?.page_h1 || '').toUpperCase();
    },
  }
})
